import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './App.css';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { auth } from './config/firebase';
import PublicLayout from './layouts/PublicLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import FaqPage from "./pages/FaqPage";
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import CancellationPolicyPage from './pages/CancellationPolicyPage';
import NotFoundPage from './pages/NotFoundPage';
import LoginPage from './pages/Auth/LoginPage';
import OffersPage from './pages/OffersPage';
import OfferDetailsPage from './pages/OfferDetailsPage';
import OtpPage from './pages/Auth/OtpPage';
import SearchPage from './pages/SearchPage';
import ExplorePage from './pages/ExplorePage';
import AccountDetailPage from './pages/AccountDetailPage';
import ScrollToTop from './components/ScrollToTop';
import InviteAndEarn from './pages/InviteAndEarn';
import Wallet from './pages/Wallet';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import HotelDetailsPage from './pages/HotelDetailsPage';
import BookingCheckoutPage from './pages/BookingCheckoutPage';
import BookingHistoryPage from './pages/BookingHistoryPage';
import EditProfilePage from './pages/EditProfilePage';
import CompleteProfilePage from './pages/CompleteProfilePage';
import PaymentStatusPage from './pages/PaymentStatusPage';
import BookingDetailPage from './pages/BookingDetailPage';
import SavedHotelsPage from './pages/SavedHotelsPage';
import { FavoritesProvider } from './context/FavoritesContext';

const originalFetch = window.fetch;
window.fetch = async (...args) => {
  try {
    const response = await originalFetch(...args);
    if (response.status === 401 || response.status === 403) {
      localStorage.removeItem('auth_token');
      try { if (auth) await auth.signOut(); } catch (e) { /* no Firebase session */ }
      
      if (window.location.pathname !== '/login') {
         window.location.href = '/login';
      }
    }
    return response;
  } catch (error) {
    throw error;
  }
};

function App() {
  return (
    <FavoritesProvider>
      <ScrollToTop />
      <Routes>
        {/* public routes */}
        <Route path='/' element={<PublicLayout />}>
          <Route index element={<HomePage />} />
          <Route path='search' element={<SearchPage />} />
          <Route path='about-us' element={<AboutPage />} />
          <Route path='blogs' element={<Blogs />} />
          <Route path='blogs/:slug' element={<BlogDetail />} />
          <Route path='explore' element={<ExplorePage />} />
          <Route path='account'>
            <Route index element={<AccountDetailPage />} />
            <Route path='invite-and-earn' element={<InviteAndEarn />} />
            <Route path='wallet' element={<Wallet />} />
            <Route path='bookings' element={<BookingHistoryPage />} />
            <Route path='bookings/:id' element={<BookingDetailPage />} />
            <Route path='edit' element={<EditProfilePage />} />
            <Route path='saved-hotels' element={<SavedHotelsPage />} />
          </Route>
          <Route path='contact-us' element={<ContactPage />} />
          <Route path="offers" element={<OffersPage />} />
          <Route path="offers/:id" element={<OfferDetailsPage />} />

          {/* Booking Flow Routes */}
          <Route path='hotel/:id' element={<HotelDetailsPage />} />
          <Route path='checkout/:id' element={<BookingCheckoutPage />} />
          <Route path='payment-status' element={<PaymentStatusPage />} />
          <Route path='faq' element={<FaqPage />} />
          <Route path='terms-and-conditions' element={<TermsPage />} />
          <Route path='guest-policy' element={<TermsPage />} />
          <Route path='privacy-policy' element={<PrivacyPage />} />
          <Route path='cancellation-policy' element={<CancellationPolicyPage />} />
          <Route path='*' element={<NotFoundPage />} />
        </Route>

        <Route path='/login' element={<LoginPage />} />
        <Route path="/otp" element={<OtpPage />} />
        <Route path="/complete-profile" element={<CompleteProfilePage />} />

      </Routes>
    </FavoritesProvider>
  );
}

export default App;
